import React from "react";
import {
  OrderDetail,
  ProductDetail,
  LineDivider,
  FirstLine,
  SecondLine,
  ShippingContent,
  ShippingInfoType,
  ShippingInfoName,
  ShippingInfoValue,
  ValueMetadada,
} from "./styles";

import correiosLogo from "../../../../../assets/images/correiosIcon.svg";
import lojinhaLogo from "../../../../../assets/images/lojinhaIcon.svg";
import caminhaoLogo from "../../../../../assets/images/caminhaoIcon.svg";

const toMoneyFormat = (value) => {
  return Number(value / 100).toLocaleString("pt-br", {
    style: "currency",
    currency: "BRL",
  });
};

const subtotalValue = (products) =>
  products.items.reduce((acc, cur) => {
    const quantity_value = !cur.quantity || cur.quantity < 0 ? 1 : cur.quantity;
    return acc + Number(cur.product_price) * quantity_value;
  }, 0);

const discountValue = (products) =>
  !products.discount
    ? 0
    : products.discount.type === "amount"
    ? products.discount.value
    : subtotalValue(products) * (products.discount.value / 100);

const shippingInfo = (type) => {
  const shipping = {
    correios: {
      message: "Seu produto será entregue por:",
      logo: correiosLogo,
      title: "correios",
    },
    without_shipping_pick_up: {
      message: "Seu produto será retirado na loja:",
      logo: lojinhaLogo,
      title: "Retirada na loja",
    },
    fixed_amount: {
      message: "Seu produto será entregue pelo:",
      logo: caminhaoLogo,
      title: "lojista",
    },
    free: {
      message: "Seu produto tem entrega grátis",
      logo: caminhaoLogo,
      title: "Frete grátis",
    },
  };

  const defaultResponse = {
    message: "",
    logo: "",
    title: "",
  };

  return shipping[type] || defaultResponse;
};

// Retorna os total de juros da parcela escolhida
const getInterestValue = (interest_amount, amount) => {
  return Number(interest_amount) - Number(amount);
};

const PurchaseDetail = (props) => {
  const shipping_data = props.shippingData;
  const amount = props.amount;

  return (
    <>
      <h2>Detalhes da compra</h2>
      <OrderDetail>
        <span id="order-id">
          Pedido: <strong>{shipping_data.order}</strong>
        </span>

        {shipping_data.product_detail && (
          <ProductDetail>
            {shipping_data.product_detail.items.map((item, index) => (
              <div key={index}>
                <FirstLine>
                  <span>{item.product_name}</span>
                  <span>{toMoneyFormat(String(item.product_price))}</span>
                </FirstLine>
                <SecondLine>
                  {item.product_sku ? <span>{item.product_sku}</span> : <span />}
                  {item.quantity && <span>Quantidade: {item.quantity}</span>}
                </SecondLine>

                <LineDivider />
              </div>
            ))}
          </ProductDetail>
        )}

        <ShippingContent>
          {shipping_data.shipping_detail && (
            <ShippingInfoType>
              <span>{shippingInfo(shipping_data.shipping_detail.type).message}</span>
              <ShippingInfoName>
                <img
                  src={shippingInfo(shipping_data.shipping_detail.type).logo}
                  title={shippingInfo(shipping_data.shipping_detail.type).title}
                />
                {shipping_data.shipping_detail.delivery_name && (
                  <span>{shipping_data.shipping_detail.delivery_name}</span>
                )}
              </ShippingInfoName>

              {shipping_data.shipping_detail.delivery_time > 0 && (
                <>
                  <div id="shipping-time">
                    <span>Previsão de entrega: </span>
                    <span>
                      {shipping_data.shipping_detail.delivery_time} dia
                      {shipping_data.shipping_detail.delivery_time > 1 ? "s" : ""} út
                      {shipping_data.shipping_detail.delivery_time > 1 ? "eis" : "il"}
                    </span>
                  </div>
                  {false && <span id="track-back">Clique aqui para rastrear</span>}
                </>
              )}
            </ShippingInfoType>
          )}

          <ShippingInfoValue>
            <ValueMetadada>
              <span>Valor</span>
              <span>{toMoneyFormat(subtotalValue(shipping_data.product_detail))}</span>
            </ValueMetadada>

            {shipping_data.product_detail.discount && (
              <ValueMetadada>
                <span>Desconto</span>
                <span>{toMoneyFormat(discountValue(shipping_data.product_detail))}</span>
              </ValueMetadada>
            )}

            {shipping_data.discount_pix && (
              <ValueMetadada>
                <span>Desconto Pix</span>
                <span>{toMoneyFormat(shipping_data.discount_pix)}</span>
              </ValueMetadada>
            )}

            {shipping_data.shipping_detail?.delivery_price && (
              <ValueMetadada>
                <span>Frete</span>
                <span>{toMoneyFormat(shipping_data.shipping_detail.delivery_price)}</span>
              </ValueMetadada>
            )}

            {shipping_data.interest_value !== amount && (
              <ValueMetadada>
                <span>Juros de parcelamento</span>
                <span>{toMoneyFormat(getInterestValue(amount, shipping_data.interest_value))}</span>
              </ValueMetadada>
            )}

            <ValueMetadada>
              <span>Total</span>
              <span>{toMoneyFormat(amount)}</span>
            </ValueMetadada>
          </ShippingInfoValue>
        </ShippingContent>
      </OrderDetail>
    </>
  );
};

export default PurchaseDetail;
